; (function ($, window, document, undefined) {
    'use strict';
    Foundation.libs.categoryconfigurator = {
        name: 'categoryconfigurator',
        version: '1.0.0',
        settings: {
            callback: function () { }
        },
        init: function (scope, method, options) {
            // initialisation à conserver
            //Foundation.inherit(this, 'throttle random_str');
            var self = this;

            this.settings = this.settings || $.extend({}, this.defaults, (options || method));

            // à conserver
            this.bindings(method, options);
        },
        events: function () {
            // initialisation pratique à conserver
            var self = this;
            var S = this.S;
            var top = this.scrollY;

            this.initBindings();
        },
        initBindings: function () {
            var top = window.scrollY;

            $(document).on('scroll', () => {
                top = window.scrollY
            })

            $(this.scope)
                .off('.categoryconfigurator')
                .on('focus.fndtn.configurator', '.configuratorFacet', function (event) {
                    window.scrollTo(0, top);
                }).bind(this)
                // CHOIX D'UNE VALEUR DANS LA LISTE
                .on('change.fndtn.configurator', '[' + this.attr_name() + '] .configuratorFacet', function (event) {
                    updateProductsList($(this).val(), 1, true);
                }).bind(this)
                // CLICK SUR BOUTON DE REINITIALISATION
                .on('click.fndtn.configurator', '[' + this.attr_name() + '] #plp-configurator-reinit', function (event) {
                    updateProductsList($(this).data("href"), 1, true);
                }).bind(this)
                ;
        },

        reflow: function () { }
    };
}(jQuery, this, this.document));